import { isEmpty, isNull } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { Children, useId } from 'react';
import type { ObjektQuery } from '../../../infrastructure/graphql/__generated__/objekt';

type Objekt_objekt = Exclude<ObjektQuery['objekt'], null>;

type ObjektdatenProps = {
  objekt: Objekt_objekt | null;
};

export const Objektdaten = ({ objekt }: ObjektdatenProps) => {
  if (isNull(objekt)) {
    return null;
  }

  const objektAdresse = !isNull(objekt.adresse) ? `${objekt.adresse.strasse}, ${objekt.adresse.postleitzahl} ${objekt.adresse.ort}` : null;
  const objektAusstattung = [objekt.hatSaal && 'Saal', objekt.hatBiergarten && 'Biergarten', objekt.hatTerrasse && 'Terrasse']
    .filter(merkmal => typeof merkmal === 'string')
    .join(', ');

  return (
    <dl>
      {objektAdresse !== null ? <Attribute label="Adresse"><address className="not-italic">{objektAdresse}</address></Attribute> : null}
      <Attribute label="Kundennummer">{objekt.nummer}</Attribute>

      { !isEmpty(objekt.channel) ? <Attribute label="Channel">{objekt.channel}</Attribute> : null }
      { !isEmpty(objekt.betriebstyp) ? <Attribute label="Betriebstyp">{objekt.betriebstyp}</Attribute> : null }
      { !isEmpty(objektAusstattung) ? <Attribute label="Ausstattung">{objektAusstattung}</Attribute> : null }

      {
        objekt.additionalInformation
          .filter(({ key, value }) => !isEmpty(value))
          .map(({ key, value }) => (
            <Attribute key={key} label={key}>
              {value}
            </Attribute>
          ))
      }
    </dl>
  );
};

type AttributeProps = {
  label: string;
};

const Attribute = ({ label, children }: PropsWithChildren<AttributeProps>) => {
  const htmlId = useId();

  if (Children.count(children) === 0) {
    return null;
  }

  return (
    <>
      <dt id={htmlId} className="tds-input-label">{label}</dt>
      <dd aria-labelledby={htmlId} className="tds-input-value mb-300 last:mb-0">{children}</dd>
    </>
  );
};
